import { Flex } from '@chakra-ui/react';
import { Button } from '@mesh.ai/rabbit';
import { useHistory } from 'react-router-dom';

import { TextLabel } from 'uiToolkitV1/Typography';

export const CompensationCreationFooter = () => {
  const history = useHistory();

  const handleCancel = () => {
    history.goBack();
  };

  const handleCreateCompensationCycle = () => {
    console.log('create compensation cycle');
  };

  const isReadOnly = false;
  const isLaunching = false;
  const lastSavedTime = null;

  return (
    <Flex
      py={3}
      px={4}
      justifyContent="space-between"
      alignItems="center"
      bg="surface.F5F7F9"
      boxShadow="0px 0px 2px 0px rgba(0, 0, 0, 0.24)"
      borderBottomRadius="8px"
    >
      <Button variant="transparentOutline" onClick={handleCancel}>
        Cancel
      </Button>
      <Flex alignItems="center" gap={6}>
        {lastSavedTime && <TextLabel bold>Auto-saved, last saved at {lastSavedTime}</TextLabel>}
        <Button disabled={isReadOnly || isLaunching} onClick={handleCreateCompensationCycle}>
          {isLaunching ? 'Launching...' : 'Launch'}
        </Button>
      </Flex>
    </Flex>
  );
};
